import React, { useEffect, useRef, useState } from "react";

interface PolaroidProps {
  imgSrc: string;
  disableComment?: boolean;
  fit?: "contain" | "cover";
}

const Polaroid: React.FC<PolaroidProps> = ({
  imgSrc,
  disableComment = true,
  fit = "contain",
}) => {
  const [comment, setComment] = useState("");
  const [orientation, setOrientation] = useState("");
  const textareaRef = useRef<HTMLTextAreaElement>(null);
  const imageFitClass =
    fit === "cover"
      ? "w-full h-full object-cover object-center block"
      : "max-w-full max-h-full m-auto object-contain object-top";
  const imageWrapperClass =
    fit === "cover"
      ? "flex-1 w-full h-[80%] overflow-hidden"
      : `flex-1 w-full overflow-hidden ${
          orientation === "horizontal" ? "max-h-[80%]" : "h-[80%]"
        }`;

  useEffect(() => {
    const img = new Image();
    img.onload = function () {
      const orientation = img.width > img.height ? "horizontal" : "vertical";
      setOrientation(orientation);
    };
    img.src = imgSrc;
  }, [imgSrc]);

  return (
    <div
      className={`w-full bg-white border border-black rounded-sm p-1 space-y-1 flex flex-col justify-between ${
        orientation === "horizontal" ? "max-h-full" : "h-full"
      }`}
    >
      <div className={imageWrapperClass}>
        {imgSrc && (
          <img
            className={imageFitClass}
            src={imgSrc}
            loading="eager"
            decoding="async"
          />
        )}
      </div>
      {!disableComment && (
        <textarea
          ref={textareaRef}
          className="polaroid-comment-input w-full rounded-sm outline-none resize-none no-scrollbar"
          rows={2}
          value={comment}
          onChange={(e) => {
            const target = e.target;
            if (target.scrollHeight - target.clientHeight > 1) return;
            setComment(target.value);
          }}
        ></textarea>
      )}
    </div>
  );
};

export default Polaroid;
